import { createSlice } from '@reduxjs/toolkit'
import { setSettings } from './reducers/set-settings'
import { clrSettings } from './reducers/clr-settings'

export const initialState = {
  dashboardAccount: null,
  summon: false,
  attendance: false,
  external: null,
  mqtt: {
    username: null,
    password: null,
  },
  googleMapApiKey: null,
}

export const storeSettings = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings: setSettings,
    clrSettings,
  },
})
